export const cash = "cash";
export const card = "card";
export const credit = "credit";